/* Test-Or · kits sur mesure, fiche produit (9 oct. 2026, Claude Code pour Raphaël). Additif : chargé après test-or.js par
   sections/to-produit.liquid, il ne remplace rien. « Complétez votre kit » (snippets/to-completer.liquid) :
   - cases qui basculent la variante (data-bascule : grande pierre, balance du kit) : elles cochent l'option du formulaire
     principal, que test-or.js suit déjà (prix, panier, « Cet article », galerie) ; masquées si la variante l'a déjà ;
   - recharge au volume de la variante (data-v5 / data-v15 ; data-vol pour une variante unique) ; pierre seule masquée si la variante a la grande (data-masquer-si) ;
   - ?balance=1 et ?loupe=1 (liens du composeur) pré-cochent la balance et la loupe.
   Relecture du 9 oct. : une bascule dont la variante cible est épuisée (option désactivée par test-or.js) reste visible,
   inactive, « Épuisé » ; pour la balance, la balance vendue seule (data-repli) prend alors le relais, pré-cochage compris.
   État de chaque bascule dans data-etat : libre, actif (variante déjà choisie), epuise, sans-options.
   Soir du 9 oct. : balance au prix avec un kit (data-prix-kit, remise « Balance à 13,99 € avec votre kit ») : la remise
   exige le kit dans le panier ; case « Cet article » décochée, la balance repasse à son prix seule (data-prix-seule), sans
   prix barré. Écouté en phase de capture : data-prix est à jour avant le calcul du total par test-or.js. */
(function () {
  "use strict";
  var achat = document.querySelector("[data-achat]");
  if (!achat) return;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var form = $("form", achat);
  var choixCourant = function () { return $("input[name='id']:checked", achat) || $("input[type='hidden'][name='id']", achat); };
  var nomVariante = function () { var c = choixCourant(); return c ? c.getAttribute("data-nom") || "" : ""; };
  var idVariante = function () { var c = choixCourant(); return c ? c.value : ""; };
  var changer = function (el) { el.dispatchEvent(new Event("change", { bubbles: true })); };
  var lireJSON = function (t) { try { return JSON.parse(t || "{}"); } catch (e) { return {}; } };

  $$("[data-completer]", achat).forEach(function (bloc) {
    var btn = $("[data-completer-btn]", bloc), base = $("[data-completer-base]", bloc), totalEl = $("[data-completer-total]", bloc);
    var bascules = $$("[data-bascule]", bloc);

    // Valeur actuelle de l'option n du formulaire principal (radios name="option-n"), radio d'une valeur donnée
    var valeurOption = function (n) { var r = form && $("input[name='option-" + n + "']:checked", form); return r ? r.value : null; };
    var radio = function (n, valeur) { return form ? $$("input[name='option-" + n + "']", form).filter(function (x) { return x.value === valeur; })[0] || null : null; };
    var choisirOption = function (n, valeur) {
      var r = radio(n, valeur);
      if (r && !r.checked && !r.disabled) { r.checked = true; changer(r); return true; }
      return false;
    };

    var majBascules = function () {
      bascules.forEach(function (lab) {
        var inp = $("[data-bascule-case]", lab), n = inp.getAttribute("data-option");
        if (!form || !$("input[name='option-" + n + "']", form)) { // pas de sélecteur d'options
          lab.hidden = true; inp.checked = false; inp.disabled = true; lab.setAttribute("data-etat", "sans-options"); return;
        }
        var actif = valeurOption(n) === inp.getAttribute("data-valeur");
        if (!actif) inp.checked = false;
        // Variante cible épuisée : test-or.js désactive l'option correspondante (toutes autres options égales)
        var cible = radio(n, inp.getAttribute("data-valeur")), epuise = !actif && (!cible || cible.disabled);
        lab.hidden = actif && !inp.checked; // déjà choisie autrement (options, formules, ?variant=) : rien à proposer
        inp.disabled = epuise;
        lab.classList.toggle("is-epuise", epuise);
        lab.setAttribute("data-etat", actif ? "actif" : (epuise ? "epuise" : "libre"));
        var ecarts = lireJSON(lab.getAttribute("data-ecarts")), prix = $("[data-bascule-prix]", lab);
        if (prix) {
          if (epuise) prix.textContent = "Épuisé";
          else if (ecarts[idVariante()]) prix.textContent = ecarts[idVariante()];
        }
      });
    };
    // Balance vendue seule, relais d'une bascule épuisée (ou sans sélecteur d'options) ; cachée et décochée sinon.
    var majReplis = function () {
      $$("[data-repli]", bloc).forEach(function (lab) {
        var b = $("[data-bascule='" + lab.getAttribute("data-repli") + "']", bloc), etat = b ? b.getAttribute("data-etat") : "sans-options";
        var montrer = etat === "epuise" || etat === "sans-options", inp = $("input", lab);
        lab.hidden = !montrer;
        if (!montrer && inp.checked) { inp.checked = false; changer(inp); }
      });
    };
    var majRecharge = function () {
      var lab = $("[data-role='recharge']", bloc);
      if (!lab) return;
      // Volume : celui du nom de la variante (« 5 ml / … », « 15 ml / … ») ; sinon celui du produit (data-vol : variante unique
      // sans volume dans son nom, comme le Coffret Expert 6 × 15 ml dont data-nom est le titre du produit).
      var m = nomVariante().match(/(\d+)\s?ml\b/i);
      var vol = m ? parseInt(m[1], 10) : parseInt(lab.getAttribute("data-vol") || "5", 10);
      var cle = vol === 15 ? "data-v15" : "data-v5";
      var d = (lab.getAttribute(cle) || "").split("|");
      if (d.length < 4) return;
      var inp = $("input", lab);
      if (inp.value === d[0]) return;
      inp.value = d[0]; inp.setAttribute("data-prix", d[1]);
      var vol = $("[data-recharge-vol]", lab), prix = $("[data-recharge-prix]", lab);
      if (vol) vol.textContent = d[2];
      if (prix) prix.textContent = "+" + d[3];
      if (inp.checked) changer(inp); // total du bloc recalculé par test-or.js
    };
    var majMasques = function () {
      var nom = nomVariante();
      $$("[data-masquer-si]", bloc).forEach(function (lab) {
        var cache = nom.indexOf(lab.getAttribute("data-masquer-si")) >= 0, inp = $("input", lab);
        lab.hidden = cache;
        if (cache && inp.checked) { inp.checked = false; changer(inp); }
      });
    };
    // Bascule seule (sans autre case cochée) : le bouton du bloc ajoute la nouvelle variante, comme le bouton principal.
    var majBouton = function () {
      if (!btn || !base) return;
      var cases = $$("[data-completer-case]:checked", bloc).length;
      var bascule = bascules.some(function (lab) { return !lab.hidden && $("[data-bascule-case]", lab).checked; });
      if (!cases && bascule && base.checked) {
        btn.disabled = false;
        btn.textContent = "Ajouter au panier · " + (totalEl ? totalEl.textContent : "");
      }
    };
    // Balance au prix avec un kit seulement si le kit part aussi (case « Cet article » cochée)
    var majPrixKit = function () {
      var avecKit = !base || base.checked;
      $$("[data-prix-kit]", bloc).forEach(function (inp) {
        var lab = inp.closest("label"), b = lab && $(".prix-kit", lab), offre = b && $(".prix-kit__offre", b);
        inp.setAttribute("data-prix", inp.getAttribute(avecKit ? "data-prix-kit" : "data-prix-seule"));
        if (lab) lab.classList.toggle("is-sans-kit", !avecKit);
        if (offre) offre.textContent = b.getAttribute(avecKit ? "data-texte-kit" : "data-texte-seule");
      });
    };
    var tout = function () { majBascules(); majReplis(); majRecharge(); majMasques(); majBouton(); };

    bascules.forEach(function (lab) {
      var inp = $("[data-bascule-case]", lab);
      inp.addEventListener("change", function () {
        var n = inp.getAttribute("data-option");
        // Variante cible indisponible : la case revient à son état, rien ne change en silence
        if (!choisirOption(n, inp.getAttribute(inp.checked ? "data-valeur" : "data-retour"))) { inp.checked = !inp.checked; tout(); }
      });
    });
    achat.addEventListener("variante-change", tout);
    bloc.addEventListener("change", majPrixKit, true); // avant test-or.js, qui calcule le total sur data-prix
    bloc.addEventListener("change", majBouton); // après test-or.js, qui recalcule le bouton à chaque case

    // Pré-cochage depuis le composeur sur mesure : ?balance=1&loupe=1. Bascule épuisée : la balance vendue seule.
    tout();
    var q = new URLSearchParams(location.search), prepare = false;
    ["balance", "loupe"].forEach(function (role) {
      if (q.get(role) !== "1") return;
      var lab = $("[data-role='" + role + "']", bloc);
      if (lab && lab.hasAttribute("data-bascule") && /^(epuise|sans-options)$/.test(lab.getAttribute("data-etat") || "")) lab = $("[data-repli='" + role + "']", bloc);
      if (!lab || lab.hidden) return;
      var inp = $("input", lab);
      if (inp.disabled) return;
      if (!inp.checked) { inp.checked = true; changer(inp); }
      prepare = inp.checked || prepare;
    });
    tout();
    if (prepare) {
      bloc.classList.add("is-prepare");
      var note = document.createElement("p");
      note.className = "completer__note";
      note.textContent = bloc.getAttribute("data-texte-prepare") || "Préparé par le composeur : un clic ajoute le kit et ses accessoires.";
      if (btn) btn.parentNode.insertBefore(note, btn);
    }
  });
})();
